export const CHAPTERS_ENDPOINTS = {
  IMPORT: "/v1/chapters/import",
} as const;
